import { Phone } from "lucide-react";
import { Marigold, Sparkle } from "@/components/art/Poster";
import { useCourtyard } from "@/context/CourtyardContext";
import { Reveal } from "@/components/invite/Reveal";

export default function MessageBand() {
  const { event: ev } = useCourtyard();
  const phoneHref = `tel:${(ev.contact_phone || "").replace(/[^\d+]/g, "")}`;
  return (
    <section className="bg-pink-print on-dark relative overflow-hidden py-20 lg:py-28" aria-labelledby="message-title">
      <div className="dots-cream pointer-events-none absolute inset-0" aria-hidden="true" />
      <Marigold className="absolute right-6 top-8 w-14 sm:w-20" />
      <Sparkle className="absolute bottom-10 left-6 w-8" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <Reveal className="lg:col-span-8">
          <p className="eyebrow eyebrow-light">{ev.host_names} ka message</p>
          <h2 id="message-title" className="sr-only">Message from {ev.host_names}</h2>
          <blockquote className="font-serif-i mt-4 text-[clamp(1.9rem,6vw,3.6rem)] leading-[1.08] text-[var(--cream)]" data-testid="host-message">“{ev.message}”</blockquote>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4 lg:self-end">
          <div className="pop bg-[var(--cream)] p-6 text-[var(--navy)] lg:-rotate-2" data-testid="detail-contact">
            <p className="eyebrow">Kisse poochein?</p>
            <p className="font-poster mt-2 text-3xl leading-none">{ev.contact_label}</p>
            {ev.contact_phone && (
              <a href={phoneHref} className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-lg font-extrabold underline decoration-[var(--pink)] decoration-[3px] underline-offset-4" data-testid="contact-phone-link">
                <Phone className="h-4 w-4" aria-hidden="true" /> {ev.contact_phone}
              </a>
            )}
            {ev.contact_note && <p className="font-serif-i mt-1 text-xl">{ev.contact_note}</p>}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
